export const normalizeShipmentIdentifier = (value?: string | null) =>
  (value || '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '');

export const addUniqueShipmentIdentifier = (
  identifiers: string[],
  value?: string | null
) => {
  const displayValue = value?.trim();
  const canonicalValue = normalizeShipmentIdentifier(displayValue);
  if (
    !displayValue ||
    !canonicalValue ||
    identifiers.some(
      (identifier) => normalizeShipmentIdentifier(identifier) === canonicalValue
    )
  ) {
    return;
  }

  identifiers.push(displayValue);
};
